import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';


const MonoblockRDCreator = () => {
  const { t } = useTranslation();
  return (
    <div>
    <Typography variant="h4" gutterBottom>{t('monoblockRD')}</Typography>
    </div>
  );
};

export default MonoblockRDCreator;